import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class DamagedTypeService {
  static LOAD_TYPES = "/api/load_types/select";

  static getAllDamagedTypes = async (params: any) => {
    try {
      return await Http.get(API_URLs.settings.damagedType, params);
    } catch (error) {
      return error;
    }
  };
  static getOneDamagedType = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.settings.damagedType, id);
    } catch (error) {
      return error;
    }
  };
  static createDamagedType = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.damagedType, data);
    } catch (error) {
      return error;
    }
  };

  static updateDamagedType = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.damagedType, data);
    } catch (error) {
      return error;
    }
  };

  static deleteDamagedType = async (id: number) => {
    try {
      return await Http.delete(API_URLs.settings.damagedType, id);
    } catch (error) {
      return error;
    }
  };

  static getAllLoadTypes = async (params?: any) => {
    try {
      return await Http.get(this.LOAD_TYPES, params);
    } catch (error) {
      return error;
    }
  };
}
